import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PropertyLedgerCodeModel } from '../models/property-ledger-code.model';
import { LedgerCodesService } from '../services/ledger-codes.service';


@Injectable({
  providedIn: 'root'
})
export class LedgerCodesResolver implements Resolve<Array<PropertyLedgerCodeModel>> {

    constructor(private service: LedgerCodesService)
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<Array<PropertyLedgerCodeModel>> {
        return this.service.GetLedgerCodes();
    }
}
